import TableLoader from "../../../general/table/tableLoader";
import EmptyRow from "../../../general/table/emptyRow";
import React from "react";
import MenuTableRowItem from "./menuTable_rowItem";

type MenusTableProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean
}

const MenusTable = ({
 dataList,
 dataListTitles,
 isRequesting
}: MenusTableProps) => {
  const _dataListTitles = dataListTitles.map((item, i) => <td key={i}>{item}</td>),
    _dataList = dataList && dataList?.map((item: any, i: number) => {
      return <MenuTableRowItem item={item} key={i}/>
    });

  return (
    <table>
      <thead>
      <tr>
        {_dataListTitles}
      </tr>
      </thead>
      <tbody>
      {isRequesting ?
        <TableLoader colSpan={dataListTitles.length}/> :
        _dataList ? _dataList : <EmptyRow colSpan={dataListTitles.length} content={''}/>
      }
      </tbody>
    </table>
  )
}

export default MenusTable;
